import axios from "axios";
import store from "@/store";
import qs from "qs";
import Toast from "vant/lib/toast";
import {
	show,
	hide
} from "@/components/pageloading/index.js";

const service = axios.create({
	baseURL: process.env.VUE_APP_BASE_API,
	timeout: 20000,
	withCredentials: false,
	crossDomain: false,
});

// request interceptor
service.interceptors.request.use(
	(config) => {
		//如果没有设置请求类型默认为表单请求
		config.headers["Content-Type"] ??=
			"application/x-www-form-urlencoded;charset=UTF-8";
		// 给默认值
		config.data ??= {};

		if (store.getters.getSign) {

			config.data["s"] = store.getters.getSign;
			config.data["p"] = store.getters.getPhone;
			var paycard = store.getters.getpaycard;
			
			if (paycard === "1") {
				config.data["paycard"] = store.getters.getpaycard;
			}

		}

		config.data = qs.stringify(config.data, {
			arrayFormat: "repeat",
		});

		return config;
	},
	(error) => {
		console.log(error); // for debug
		return Promise.reject(error);
	}
);

// response interceptor
service.interceptors.response.use(
	(response) => {
		console.log('Response:', response);
		const res = response.data;

		//0正常
		if (res.code !== 0) {
			return Promise.reject(res);
		} else {
			// 如果 data 是字符串，尝试解析 JSON
			if (typeof res.data === 'string') {
				try {
					res.data = JSON.parse(res.data);
				} catch (error) {
					console.log('JSON parse error:', error);
				}
			}
			console.log('Final data:', res.data);
			return res;
		}
	},
	(error) => {
		return Promise.reject(error);
	}
);

//错误信息处理
service.interceptors.response.use(
	(response) => {
		hide();
		return response;
	},
	(error) => {
		hide();
		Toast(error.data || error.message), console.log("请求错误", error.data);
		return Promise.reject(error);
	}
);

/**
 * post请求
 * @param {请求地址} url
 * @param {请求参数} data
 * @param {配置} config
 */
export function rPost(url, data, config = {}) {
	if (config.isLoad) {
		show();
	}

	config["method"] = "post";
	config["data"] = data;
	config["url"] = url;

	return service(config);
}

/**
 * get请求
 * @param {请求地址} url
 * @param {请求参数} data
 * @param {配置} config
 */
export function rGet(url, data, config = {}) {
	config["method"] = "get";
	config["params"] = data;
	config["url"] = url;

	return service(config);
}

export default service;